<template>
  <v-dialog v-model="dialogVisible" max-width="450">
    <v-card>
      <v-stepper v-model="step" vertical>
        <!-- Step 1: Language Selection -->
        <v-stepper-step :complete="step > 1" step="1">
          {{ $t('msg.selectLanguage') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-card flat>
            <v-card-text>
              <v-radio-group v-model="selectedLanguage" mandatory>
                <v-radio label="English" value="en"></v-radio>
                <v-radio label="Fijian" value="fj"></v-radio>
                <v-radio label="Samoan" value="sm"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="nextStep">{{ $t('msg.next') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!-- Step 2: Report Confirmation -->
        <v-stepper-step :complete="step > 2" step="2">
          <b>{{ $t('msg.confirmReportTitle') }}</b> <br>{{ $t('msg.confirmReport') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-card flat>
            <v-card-text>
              <p>{{ $t('msg.unlock_report_confirmation') }}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="cancel">{{ $t('msg.no') }}</v-btn>
              <v-btn color="primary" text @click="confirm">{{ $t('msg.yes') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['title', 'message'],
  data() {
    return {
      dialogVisible: false,
      step: 1,
      selectedLanguage: null,
      internalReportType: null,
      username: null
    };
  },
  methods: {
    open({ reportType, username }) {
      this.internalReportType = reportType;
      this.username = username;
      this.dialogVisible = true;
      this.step = 1;
      this.selectedLanguage = null;
    },
    nextStep() {
      if (this.step === 1 && this.selectedLanguage) {
        this.step++;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.step = 1;
      this.selectedLanguage = null;
    },
    confirm() {
      this.$emit('confirmed', this.internalReportType, this.username, this.selectedLanguage);
      this.dialogVisible = false;
      this.step = 1;
      this.selectedLanguage = null;
    }
  }
};
</script>